import React, {useEffect, useState} from "react";
import {Progress} from 'antd';

interface Props {
    slide: number,
    showNextSlide:  () => void,
    duration: number,
    disabled?: boolean
}

const updateInterval = 100;
export const AutoNextOnTimeout = ({slide, showNextSlide, duration, disabled= false}: Props) => {
    const [slideDisplayTime, updateSlideDisplayTime] = useState(0);

    useEffect(() => {
        if (disabled) return () => {};

        const interval = setInterval(() => {
            if (slideDisplayTime > duration) {
                updateSlideDisplayTime(0);
                showNextSlide();
            } else {
                updateSlideDisplayTime(slideDisplayTime + updateInterval);
            }
        }, updateInterval);
        return () => clearInterval(interval);
    }, [slide, slideDisplayTime, updateSlideDisplayTime, duration, showNextSlide, disabled]);

    const percent = 100 - Math.min(100, slideDisplayTime / duration * 100);

    return <Progress type="circle" percent={percent} showInfo={false} size={20}/>;
};
